import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FeatureCreateRequestBody, FeatureCreateResponse } from "./types";

export class FeatureCreateAPI extends BaseAPI<
    FeatureCreateRequestBody,
    FeatureCreateResponse
> {
    protected route = ApiRoutes.feature.create;
    protected method = RequestMethod.POST;
}
